import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Linkedin, Flag } from "lucide-react";
import { useEffect } from "react";
const productLinks = [{
  label: "Certifications RNCP RS",
  href: "/RncpRsCertificationsPage"
}, {
  label: "Certification Qualiopi®\xA0",
  href: "/ProfessionalTrainingQualityPage"
}, {
  label: "Cadre juridique de la formation professionnelle\xA0",
  href: "/TrainingLegalFrameworkPage"
}];
const companyLinks = [{
  label: "Accueil",
  href: "/HomePage"
}, {
  label: "Qui suis-je ?",
  href: "/WhoAmIPage"
}, {
  label: "Contact",
  href: "/ContactPage"
}];
const resourceLinks = [{
  label: "06 40 86 81 29",
  href: "tel:+33640868129"
}];
const socialLinks = [{
  icon: Linkedin,
  href: "https://fr.linkedin.com/in/christellecharrier-robelin",
  label: "LinkedIn – Christelle Charrier-Robelin"
}];
const legalLinks = [{
  label: "Mentions légales",
  href: "/LegalNoticePage"
}, {
  label: "Politique de confidentialité",
  href: "/PrivacyPolicyPage"
}];

// Documents qualité / conformité téléchargeables
const qualityDocuments = [{
  label: "Certificat Qualiopi® Effet Conseil",
  href: "https://docs.google.com/viewer?url=https://working-starling.10web.cloud/wp-content/uploads/2026/04/23FOR01994.1-Certificat-de-conformite.pdf&embedded=false"
}, {
  label: "Règlement intérieur Stagiaires Effet Conseil",
  href: "https://effet-conseil.com/wp-content/uploads/2026/05/20250101_EFFET-CONSEIL_Reglement-interieur.pdf"
}];
export default function Footer() {
  useEffect(() => {
    const el = document.getElementById("ec-email-footer");
    if (el && !el.hasChildNodes()) {
      const u = "christelle";
      const d = "effet-conseil.com";
      const a = document.createElement("a");
      a.href = "mai" + "lto:" + u + "@" + d;
      a.className = "text-white hover:text-white/70 transition-colors duration-200 text-[14px]";
      a.textContent = u + "@" + d;
      el.appendChild(a);
    }
  }, []);
  return <section data-section-id="166076" id="footer" className="bg-[#62751D] pt-12 pb-6 border-t border-white/10 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 text-center md:grid-cols-2 md:text-left lg:grid-cols-4 lg:gap-8">
          {/* Expertise */}
          <div>
            <h3 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">
              Expertise
            </h3>
            <ul className="flex flex-col gap-2">
              {productLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-white hover:text-white/70 transition-colors duration-200 text-[14px]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Informations */}
          <div>
            <h3 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">
              Informations
            </h3>
            <ul className="flex flex-col gap-2">
              {companyLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-white hover:text-white/70 transition-colors duration-200 text-[14px]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">
              Contact
            </h3>
            <ul className="flex flex-col gap-2">
              {/* Nom et titre */}
              <li className="text-white/90 text-[14px] font-semibold leading-snug">
                Christelle CHARRIER-ROBELIN
                <br />
                <span className="font-normal text-white/70 text-[13px]">
                  Fondatrice &amp; Consultante
                </span>
              </li>

              {resourceLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-white hover:text-white/70 transition-colors duration-200 text-[14px]">
                    {link.label}
                  </Link>
                </li>)}

              <li id="ec-email-footer" />

              <li aria-hidden="true" style={{
              position: "absolute",
              left: "-9999px",
              opacity: 0,
              height: 0,
              width: 0,
              overflow: "hidden",
              tabIndex: -1
            } as React.CSSProperties}>
                <label>
                  Ne pas remplir ce champ
                  <input type="email" name="website_email" tabIndex={-1} autoComplete="off" />
                </label>
              </li>

              {/* Documents qualité / conformité */}
              {qualityDocuments.map((doc, i) => <li key={doc.label} data-index={i}>
                  <a href={doc.href} target="_blank" rel="noopener noreferrer" className="text-white hover:text-white/70 transition-colors duration-200 text-[14px]">
                    {doc.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Social + France */}
          <div className="flex flex-col items-center gap-6 md:items-start">
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} newTab className="text-white hover:text-white/70 transition-colors duration-200" aria-label={social.label} data-index={i}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <div className="flex items-center gap-2 text-[14px] text-white bg-white/10 w-fit px-3 py-2 rounded-[2px] border border-white/20">
              <Flag className="size-4 text-white" />
              <span>France</span>
            </div>
          </div>
        </div>

        <Separator className="my-6 bg-white/20" />

        {/* Bas du footer */}
        <div className="flex flex-col items-center gap-2 text-[12px] text-white md:flex-row md:justify-between">
          <p>© 2026 Effet Conseil. Tous droits réservés.</p>
          <div className="flex items-center flex-wrap justify-center gap-2">
            {legalLinks.map((link, i) => <div key={link.label} data-index={i} className="flex items-center gap-2">
                <Link to={link.href} className="hover:text-white/70 transition-colors duration-200">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="text-white/30 px-1">•</span>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}